<template>
    <!-- <div>我是竞赛信息</div> -->
    <div class="view-wrapper" ref="blockimg">
        <div class="cmpt-background text-block">
            <div class="title"><p class="innerShadow">大赛背景</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-html="backGround"></p>
            </div>
        </div>
        <div class="cmpt-background text-block">
            <div class="title"><p class="innerShadow">赛题描述</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-html="dcCmptsetting.taskDescription"></p>
            </div>
        </div>
        <div class="cmpt-background text-block">
            <div class="title"><p class="innerShadow">数据说明</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-html="dcCmptsetting.datasetDescription"></p>
            </div>
        </div>
        <div class="cmpt-background text-block">
            <div class="title"><p class="innerShadow">提交说明</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-html="dcCmptsetting.uploadDataFormat"></p>
            </div>
        </div>
        <div class="schedule text-block">
            <div class="title"><p class="innerShadow">{{ $t('dc_lang.时间安排') }}</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-if="hasTimeProcess" v-html="timeProcess"></p>
                <p v-else class="text-wrapper" v-html="timeProcess"></p>
            </div>
        </div>
        <div class="award text-block">
            <div class="title"><p class="innerShadow">大赛奖项</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-html="rewardTypeInfo"></p>
            </div>
        </div>
        <div class="award text-block">
            <div class="title"><p class="innerShadow">评分标准</p></div>
            <div class='wxparse-content'>
                <p class="text-wrapper" v-html="dcCmptsetting.evaluationCriteria"></p>
            </div>
        </div>
        <div class="cmpt-rule text-block">
            <div class="title"><p class="innerShadow">{{ $t('dc_lang.参赛与组队规则') }}</p></div>
            <div>
                <div class="im-write">
                    <template v-show="name=='“2019 创青春•新网智能交子杯”高校金融挑战赛-AI算法赛道'
                ||name=='“2019 创青春•新网智能交子杯”高校金融挑战赛-分布式集群算法赛道'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </template>
                    {{ $t('dc_lang.所有参赛人员及队伍，视为已同意') }}<span @click="toManagularPage" class="toManagular"
                                                             style='color:#4DA6FF;'>{{ $t('dc_lang.《DC竞赛作弊管理规则》') }}</span>{{ $t('dc_lang.及其他相关规定。队长对其队员的参赛行为负责。') }}
                </div>
                <p class="text-wrapper" v-html="additionalRules"></p>
                <!-- 固定显示的规则部分 -->
                <div class='more-rules' v-if="name=='“2019 创青春•新网智能交子杯”高校金融挑战赛-AI算法赛道'
                ||name=='“2019 创青春•新网智能交子杯”高校金融挑战赛-分布式集群算法赛道'">
                    <p v-for="(item,index) in rulesFixedXinwang" :key="index">
                        <template>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</template>
                        {{ item.detail }}
                    </p>
                </div>
                <div class='more-rules'
                     :class="(dcCompetition.id==333 || dcCompetition.id==334 || dcCompetition.id==335)?'indent2':''"
                     v-else-if="dcCompetition.id!='320'">
                    <p v-for="(item,index) in rulesFixedXinwang" :key="index">{{ item.detail }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/api.js'

export default {
    name: 'competition-message',
    data () {
        return {
            mts: 5,
            timeProcess: '', // 固定的上线时间
            hasTimeProcess: '', // 原本有计划的上线时间
            /* rulesFixed:[
                          {
                              detail:this.$t('dc_lang.团队人数上限5人')
                          },
                          {
                              detail:'在第一阶段的最后3天无法新建队伍，但是可以加入其它队伍。'
                          },
                          {
                              detail:'在最后一个阶段最后3天无法新建队伍，无法加入队伍。'
                          },
                          {
                              detail:'竞赛进入历史阶段后可以新建队伍，但是已参赛队伍不可新增队员、不可解散队伍，注意：答辩队伍成员仅限活跃期间加入的成员。'
                          }
                      ],//固定的页面的规则的显示 */
            name: '', // 请求详情需要传递的竞赛名字
            cmptId: '', // 请求详情需要传递的竞赛ID
            cmptDetail: {},
            dcCmptsetting: {},
            backGround: '',
            rewardTypeInfo: '',
            additionalRules: '',
            dcCompetition: {},
            remark: ''
        }
    },
    computed: {
        rulesFixed: function () { // 获取验证码按钮txt
            return [
                {
                    detail: '团队人数上限' + this.mts + '人'
                },
                {
                    detail: '在第一阶段的最后3天无法新建队伍，但是可以加入其它队伍。'
                },
                {
                    detail: '在最后一个阶段最后3天无法新建队伍，无法加入队伍。'
                },
                {
                    detail: '竞赛进入历史阶段后可以新建队伍，但是已参赛队伍不可新增队员、不可解散队伍，注意：答辩队伍成员仅限活跃期间加入的成员。'
                }
            ]// 固定的页面的规则的显示;
        },
        rulesFixedXinwang: function () { // 获取验证码按钮txt
            return [
                {
                    detail: '团队人数上限' + this.mts + '人'
                },
                {
                    detail: '新建队伍截止时间为' + this.common.format(this.dcCmptsetting.createteamCutofftime ? this.dcCmptsetting.createteamCutofftime : null, 'yyyy年MM月dd日 HH:mm:ss')
                },
                {
                    detail: '加入其它队伍截止时间为' + this.common.format(this.dcCmptsetting.jointeamCutofftime ? this.dcCmptsetting.jointeamCutofftime : null, 'yyyy年MM月dd日 HH:mm:ss')
                },
                {
                    detail: '合并队伍截止时间为' + this.common.format(this.dcCmptsetting.mergeteamCutofftime ? this.dcCmptsetting.mergeteamCutofftime : null, 'yyyy年MM月dd日 HH:mm:ss')
                },
                {
                    detail: '竞赛进入历史阶段后可以新建队伍，但是已参赛队伍不可新增队员、不可解散队伍，注意：答辩队伍成员仅限活跃期间加入的成员。'
                }
            ]// 固定的页面的规则的显示;
        }
    },
    methods: {
        // 点击前往DC作弊规则管理页面
        toManagularPage () {
            this.$router.push({path: '/competition-managerule'})
        },
        // 请求竞赛详情
        getCmptDetail () {
            const me = this
            api.competitionDetailsUrl({
                id: me.cmptId,
                detail: '竞赛信息'
            }).then(response => {
                me.common.axiosSuccessFun({
                    this: me,
                    callBack (res) {
                        // 更新报名参赛后的队伍信息
                        me.cmptDetail = res.data.cmptDetail ? res.data.cmptDetail : {}
                        me.dcCompetition = res.data.cmptDetail.dcCompetition ? res.data.cmptDetail.dcCompetition : {}
                        me.dcCmptsetting = res.data.cmptDetail.dcCmptsetting ? res.data.cmptDetail.dcCmptsetting : {}
                        me.mts = me.cmptDetail.dcCmptsetting.mts
                        // 竞赛背景
                        me.backGround = res.data.cmptDetail.dcCompetition.backGround ? res.data.cmptDetail.dcCompetition.backGround : ''

                        me.backGround = JSON.parse(JSON.stringify(me.backGround).split('_%E7%AB%9E%E8%B5%9B%E4%BF%A1%E6%81%AF.html').join(''))
                        me.backGround = JSON.parse(JSON.stringify(me.backGround).split('_竞赛信息.html').join(''))
                        me.backGround = JSON.parse(JSON.stringify(me.backGround).split('https://www.dcjingsai.com/common/cmpt/').join('/competition-message?name='))
                        me.backGround = JSON.parse(JSON.stringify(me.backGround).split('https://www.pkbigdata.com/common/cmpt/').join('/competition-message?name='))

                        // 竞赛2019数据智能算法大赛 字号修改(将size="4"改成跟参赛背景的字一样)
                        // 新网 字号修改(将size="4"改成跟参赛背景的字一样)
                        if (me.dcCompetition.id == '307' || me.dcCompetition.id == '308' || me.dcCompetition.id == '303') {
                            me.backGround = me.backGround.split('size="4"').join('size="4" style="font-weight:700;"')
                        }

                        // 竞赛奖项
                        me.rewardTypeInfo = res.data.cmptDetail.dcCompetition.rewardTypeInfo ? res.data.cmptDetail.dcCompetition.rewardTypeInfo : ''
                        // 竞赛时间安排
                        me.timeProcess = res.data.cmptDetail.dcCompetition.timeProcess ? res.data.cmptDetail.dcCompetition.timeProcess : ''
                        if (me.timeProcess && (me.timeProcess !== null || me.timeProcess != '')) {
                            me.hasTimeProcess = true
                        } else {
                            me.timeProcess2 = res.data.timeInfo
                            me.hasTimeProcess = false
                        }
                        // 参赛与组队规则
                        me.additionalRules = res.data.cmptDetail.dcCmptsetting.additionalRules ? res.data.cmptDetail.dcCmptsetting.additionalRules : ''
                    }
                }, response.data)
            }).catch(error => {
                me.common.axiosFailFun({
                    this: me
                }, error)
            })
        }
    },
    // 获取数据详情
    // getDataList () {
    //     const me = this
    //     api.getDataList({cmptId: this.cmptId})
    //         .then(res => {
    //             me.remark = res.data.datasetDescription;
    //         })
    // },
    created () {
        const me = this
        me.cmptId = this.$route.query.id
        if (me.cmptId) {
            me.getCmptDetail()
            // me.getDataList()
        } else {
            return false
        }
    },
    destroyed: function () {
        this.$parent.$parent.$refs.alertCompo.closeAlert()
    }

}
</script>

<style scoped lang="scss">
.view-wrapper {
    font-size: 28px; /*px*/
    padding: 30px 31px 38px 30px;
    background-color: #ffffff;
    height: 100%;

    .text-block {
        margin-top: 30px;
        width: 100%;
    }

    .text-block:first-child {
        margin-top: 0;
    }

    .title {
        font-size: 36px; /*px*/
        color: #17181A;
        font-weight: bold;
        margin-bottom: 30px;
        display: inline-block;
    }

    .wxparse-content {
        font-size: 28px; /*px*/
        color: #000032;
    }
}

.cmpt-rule {
    .im-write {
        // color: #797C80;
        color: #000032;
        font-size: 28px; /*px*/
        line-height: 40px;
    }
}

.more-rules {
    color: #000032;
    font-size: 28px; /*px*/
    line-height: 40px;
}

.indent2 {
    text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/competition/competition-detail-tab/competition-message/competition-message.vue